import React, { useState, useRef } from "react";
import TextInput from "../../../reuse/formComponets/TextInput";
import Upload from "../../../../assets/images/upload.png";

function CategoryAdd() {
  const [isVisible, setIsVisible] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const fileInputRef = useRef(null);
  const [subCategories, setSubCategories] = useState([""]);

  const handleOpen = () => setIsVisible(true);
  const handleClose = () => setIsVisible(false);

  const handleBoxClick = () => fileInputRef.current.click();

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setSelectedImage(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const handleAddSubCategory = () => {
    setSubCategories([...subCategories, ""]);
  };

  const handleRemoveSubCategory = (index) => {
    setSubCategories(subCategories.filter((_, i) => i !== index));
  };

  const handleSubCategoryChange = (index, value) => {
    const updatedSubCategories = [...subCategories];
    updatedSubCategories[index] = value;
    setSubCategories(updatedSubCategories);
  };

  return (
    <>
      <button
        onClick={handleOpen}
        className="bg-gray-200 hover:bg-gray-100 px-4 py-2 rounded-md "
      >
        <i className="fa fa-plus mr-2" aria-hidden="true"></i>
        Add Category
      </button>

      {isVisible && (
        <div className="fixed inset-0 flex items-center justify-center bg-opacity-30 backdrop-blur-sm z-50">
          {/* Add this div for backdrop blur effect */}
          <div className="fixed inset-0 bg-black/30 backdrop-blur-sm"></div>
          
          <div className="relative z-10 lg:w-[65%] md:w-[65%] w-[90%] p-8 border rounded-md shadow-lg bg-white">
            <div className="flex justify-between items-center mb-4">
              <h2>Add Category</h2>
              <i
                className="fa fa-times text-2xl cursor-pointer hover:text-red-600"
                aria-hidden="true"
                onClick={handleClose}
              ></i>
            </div>

            <div className="NewCategory lg:flex  items-center gap-8">
              <div
                className="lg:w-32 lg:h-32 md:w-32 md:h-32 w-[300px] h-[200px]  border flex items-center justify-center rounded-md cursor-pointer"
                onClick={handleBoxClick}
              >
                {selectedImage ? (
                  <img
                    src={selectedImage}
                    alt="Uploaded"
                    className="w-full h-full object-contain "
                  />
                ) : (
                  <img
                    src={Upload}
                    alt="Upload"
                    className="w-full h-full object-contain border-dotted "
                  />
                )}
              </div>

              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                ref={fileInputRef}
                className="hidden"
              />

              <TextInput
                label="Category Name"
                type="text"
                placeholder="Enter category name"
              />

              <div className="grid grid-cols-2 gap-4 pt-4">
                {subCategories.map((subCategory, index) => (
                  <div key={index} className="flex items-center gap-2">
                    <TextInput
                      label={`SubCategory ${index + 1}`}
                      type="text"
                      placeholder="Enter sub category"
                      value={subCategory}
                      onChange={(e) =>
                        handleSubCategoryChange(index, e.target.value)
                      }
                    />
                    <button
                      className="text-red-500 pt-7"
                      onClick={() => handleRemoveSubCategory(index)}
                    >
                      <i className="fa fa-trash text-red-500 text-sm"></i>
                    </button>
                  </div>
                ))}
              </div>

              <button
                onClick={handleAddSubCategory}
                className="text-primary flex items-center gap-2 hover:text-primary/90"
              >
                <i className="fa fa-plus   pt-7"></i>
                <p className="pt-7 ">SubCategory</p>
              </button>
            </div>

            <button className="mt-4 px-4 py-2 w-full bg-primary text-white rounded-md hover:bg-primary/90">
              Add Category
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default CategoryAdd;
